import { ModalHandler } from "@lib/ModalHandler";
import { getRandomizedString, randNum } from "@lib/util/common";
import { Accessor } from "solid-js";
import {
  clickSaveButton,
  getQuestionHandler,
  waitForRegularSectionPage,
  waitForSOMainMenu,
} from "../form_handlers";
import { clickSurveySection } from "../form_util";

export async function completeClrxPresets(_totalStocked: number, modalHandler: Accessor<ModalHandler>) {
  await fillUnitsAndCasesOverall(modalHandler);
  await fillShelfAfter(modalHandler);
  await fillDisplayMaintenance(modalHandler);
  await fillEdlpTprAdProgram(modalHandler);
  await fillClientIntelligence(modalHandler);
  await fillKingsford(modalHandler);
  await fillBozzAuditSurvey(modalHandler);
}

async function fillUnitsAndCasesOverall(modalHandler: Accessor<ModalHandler>) {
  const [clicked] = await clickSurveySection(
    /units and cases overall/i,
    modalHandler,
    waitForRegularSectionPage,
    true
  );
  if (!clicked) {
    return;
  }

  getQuestionHandler("textinput", 1, "How many units of Hidden Valley Ranch did you packout?")?.answer("0");
  getQuestionHandler("textinput", 2, "How many cases of Hidden Valley Ranch did you ordered toward?")?.answer(
    "0"
  );
  getQuestionHandler("textinput", 3, "How many units of Kingsford Charcoal did you packout?")?.answer("0");
  getQuestionHandler("textinput", 4, "How many cases of Kingsford Charcoal did you ordered toward?")?.answer(
    "0"
  );
  getQuestionHandler("textinput", 5, "How many units of Clorox Laundry did you packout?")?.answer("0");
  getQuestionHandler("textinput", 6, "How many cases of Clorox Laundry did you ordered toward?")?.answer("0");
  getQuestionHandler("textinput", 7, "How many units of Clorox Homecare did you packout?")?.answer("0");
  getQuestionHandler("textinput", 8, "How many cases of Clorox Homecare did you ordered toward?")?.answer(
    "0"
  );
  getQuestionHandler("textinput", 9, "How many units of Fresh Step/Scoop Away did you packout?")?.answer("0");
  getQuestionHandler(
    "textinput",
    10,
    "How many cases of Fresh Step/Scoop Away did you ordered toward?"
  )?.answer("0");
  getQuestionHandler("textinput", 11, "How many units of Glad did you packout?")?.answer("0");
  getQuestionHandler("textinput", 12, "How many cases of Glad did you ordered toward?")?.answer("0");
  getQuestionHandler("textinput", 13, "How many units of Glad Wrap did you packout?")?.answer("0");
  getQuestionHandler("textinput", 14, "How many cases of Glad Wrap did you ordered toward?")?.answer("0");
  getQuestionHandler("textinput", 15, "How many units of Glad Bag did you packout?")?.answer("0");
  getQuestionHandler("textinput", 16, "How many cases of Glad Bag did you ordered toward?")?.answer("0");

  clickSaveButton();
  await waitForSOMainMenu(modalHandler);
}

async function fillShelfAfter(modalHandler: Accessor<ModalHandler>) {
  const [clicked] = await clickSurveySection(
    /shelf after/i,
    modalHandler,
    waitForRegularSectionPage,
    true,
    true
  );
  if (!clicked) {
    return;
  }

  /******************** Begin Questions ********************/
  getQuestionHandler("radio", 1, /did you add units.*shelf.*outside.*dist.*check/i)?.answer("YES");
  getQuestionHandler("textinput", 2, /unit.*added.*outside of the distribution check/i)?.answer(
    randNum(12, 18).toString()
  );
  getQuestionHandler("textinput", 4, /tag.*added.*outside of the distribution check/i)?.answer(
    randNum(0, 1).toString()
  );
  getQuestionHandler("textinput", 5, /total orders placed outside of the distribution check/i)?.answer(
    randNum(0, 2).toString()
  );

  /******************** End Questions ********************/

  clickSaveButton();
  await waitForSOMainMenu(modalHandler);
}

async function fillDisplayMaintenance(modalHandler: Accessor<ModalHandler>) {
  const [clicked] = await clickSurveySection(
    /display maintenance/i,
    modalHandler,
    waitForRegularSectionPage,
    true
  );
  if (!clicked) {
    return;
  }

  /******************** Begin Questions ********************/
  getQuestionHandler("radio", 1, "Did you see any existing display(s) in the store?")?.answer("NO");
  getQuestionHandler("radio", 4, "Did you add units to the existing displays?")?.answer("NO");
  getQuestionHandler("radio", 6, "Why were you unable to packout?")?.answer("No additional inventory");
  getQuestionHandler("radio", 8, "Did you see any built units of new displays?")?.answer("NO");
  getQuestionHandler("radio", 11, "Did you add units to new displays?")?.answer("NO");
  getQuestionHandler("radio", 13, "Why were you unable to packout?")?.answer("No additional inventory");

  /******************** End Questions ********************/

  clickSaveButton();
  await waitForSOMainMenu(modalHandler);
}

async function fillEdlpTprAdProgram(modalHandler: Accessor<ModalHandler>) {
  const [clicked] = await clickSurveySection(
    /edlp.*tpr.*ad program/i,
    modalHandler,
    waitForRegularSectionPage,
    true
  );
  if (!clicked) {
    return;
  }

  /******************** Begin Questions ********************/
  getQuestionHandler("radio", 1, /ensure you share upcoming ads/i)?.answer("I undertand the directive");
  getQuestionHandler("radio", 2, /did you confirm edlp/i)?.answer("NO");

  /******************** End Questions ********************/

  clickSaveButton();
  await waitForSOMainMenu(modalHandler);
}

async function fillClientIntelligence(modalHandler: Accessor<ModalHandler>) {
  const [clicked] = await clickSurveySection(
    /client intelligence/i,
    modalHandler,
    waitForRegularSectionPage,
    true
  );
  if (!clicked) {
    return;
  }

  /******************** Begin Questions ********************/
  getQuestionHandler(
    "radio",
    1,
    /did you see any.*these items on the shelf.*spanish language on the label/i
  )?.answer("NO");
  getQuestionHandler("textinput", 6, "Comment")?.answer(getRandomizedString(["n", ".,/", "a"]));

  /******************** End Questions ********************/

  clickSaveButton();
  await waitForSOMainMenu(modalHandler);
}

async function fillKingsford(modalHandler: Accessor<ModalHandler>) {
  const [clicked] = await clickSurveySection(
    /bozzutos|charcoal display maint/i,
    modalHandler,
    waitForRegularSectionPage,
    true
  );
  if (!clicked) {
    return;
  }

  /******************** Begin Questions ********************/
  getQuestionHandler("radio", 1, "Did you see any existing Kingsford 16lb display(s) in the store?")?.answer(
    "NO"
  );
  getQuestionHandler("radio", 4, "Did you see Kingsford 16lb units before packout?")?.answer("NO");
  getQuestionHandler("radio", 6, "Did you add Kingsford 16lb units in the existing displays?")?.answer("NO");
  getQuestionHandler(
    "radio",
    8,
    "Did you see any existing Match Light 12lb display(s) in the store?"
  )?.answer("NO");
  getQuestionHandler("radio", 11, "Did you see Match Light 12lb units before packout?")?.answer("NO");
  getQuestionHandler("radio", 13, "Did you add Match Light 12lb units in the existing displays?")?.answer(
    "NO"
  );
  getQuestionHandler("radio", 15, "Did you see built Kingsford 16lb units of new displays?")?.answer("NO");
  getQuestionHandler("radio", 18, "Did you add Kingsford 16lb units to new displays?")?.answer("NO");
  getQuestionHandler("radio", 21, "Did you see built Match Light 12lb units of new displays?")?.answer("NO");
  getQuestionHandler("radio", 24, "Did you add Match Light 12lb units to new displays?")?.answer("NO");

  /******************** End Questions ********************/

  clickSaveButton();
  await waitForSOMainMenu(modalHandler);
}

async function fillBozzAuditSurvey(modalHandler: Accessor<ModalHandler>) {
  const [clicked] = await clickSurveySection(
    /bozz audit survey/i,
    modalHandler,
    waitForRegularSectionPage,
    true
  );
  if (!clicked) {
    return;
  }

  /******************** Begin Questions ********************/
  getQuestionHandler("radio", 1, "Did store received a Kingsford Jason Kelce Display Kit?")?.answer("NO");
  getQuestionHandler("radio", 4, "Is this display on the sales floor?")?.answer(
    "NO, MANAGER REFUSED DISPLAY"
  );

  /******************** End Questions ********************/

  clickSaveButton();
  await waitForSOMainMenu(modalHandler);
}
